<template>
  <div class="footer">
    <div class="PC-footer">
      <footer id="footer-container">
        <section class="footer-contact footer-item">
          <div class="footer-title-one">联系我们</div>
          <div class="footer-title-two">售后电话：02039301600</div>
          <div class="footer-title-two">总部地址：广州市南沙区东涌镇银沙大街31号</div>
          <div class="footer-title-one">客服服务</div>
          <div class="footer-title-two">查询蹀愫精品店</div>
          <div class="footer-title-two">
            <select class="search-shop" v-model="shop" @change="toShopPage">
              <option value="" selected="selected">请选择</option>
              <option v-for="(item,index) in provinceData" :key="index" :value="item.value">{{item.name}}</option>
            </select>
          </div>
        </section>
        <section class="footer-shopping footer-item">
          <div class="footer-title-one">购物帮助</div>
          <div class="shop-style">
            <a class="shop-item" target="_blank" href="https://tigrisso.tmall.com/">天猫</a>
          </div>
          <div class="shop-style">
            <a class="shop-item" target="_blank" href="">京东</a>
          </div>
          <div class="shop-style">
            <a class="shop-item" target="_blank" href="https://mst.vip.com/pY4UXyQ7V78OaUhSLTzXiw.php?client=pc&wapid=mst_2750780&extra_type=3">唯品会</a>
          </div>
        </section>
        <section class="footer-follow footer-item">
          <div class="footer-title-one">关注我们</div>
          <div class="footer-title-two">
            <p>想率先获取最新作品的信息及蹀愫tigrisso各领域的独家消息</p>
            <p>请关注以下官方渠道：</p>
          </div>
          <div class="follow-item">
            <div class="follow-item-detail">
              <img src="../assets/images/pc/weixin.jpg"/>
              <p>蹀愫官方微信</p>
            </div>
            <div class="follow-item-detail">
              <img src="../assets/images/pc/weibo.jpg"/>
              <p>蹀愫官方微博</p>
            </div>
            <div class="follow-item-detail">
              <img src="../assets/images/pc/tianmao.jpg"/>
              <p>蹀愫天猫旗舰店</p>
            </div>
          </div>
        </section>
      </footer>
      <div id="footer-record">
        <div>天创时尚股份有限公司版权所有 | <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备11000016号</a></div>
        <div style="width:300px;margin:0 auto; padding:20px 0;"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011502000765" target="_blank" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
           <img src="../assets/images/beian.png" style="float:left;"/>
           <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44011502000765号</p>
        </a></div>
      </div>
    </div>
    <div class="mobile">
      <footer>
        <section class="footer-one">
          <div class="footer-coordinate">
            <div @click="getNearestShop">
              <img src="../assets/images/layout/coordinate.png" alt="">
              <span>蹀愫精品店</span>
            </div>
          </div>
          <div class="footer-contact">
            <div @click="dialog({type:1,open:true})">
              <img src="../assets/images/layout/telephone.png" alt="">
              <span>联系我们</span>
            </div>
          </div>
        </section>
        <section class="footer-search">
          <div class="title">查询蹀愫精品店</div>
          <div class="search">
            <select v-model="shop" @change="toShopPage">
              <option v-for="(item,index) in provinceData" :key="index" :value="item.value">{{item.name}}</option>
            </select>
          </div>
        </section>
        <section class="footer-ts-platform">
          <div class="weixin" @click="dialog({type:3,open:true})">
            <img src="../assets/images/mobile/weixin.png" alt="">
          </div>
          <div class="weibo">
            <a target="_blank" href="https://weibo.com/tigrissolady?refer_flag=1001030103_"><img src="../assets/images/mobile/weibo.png" alt=""></a>
          </div>
        </section>
        <section class="footer-shopping">
          <div class="tianmao">
            <a class="shop-item" target="_blank" href="https://tigrisso.tmall.com/"><img src="../assets/images/mobile/tianmao.png" alt=""></a>
          </div>
          <div class="JD">
            <img src="../assets/images/mobile/JD.png" alt="">
          </div>
          <div class="special-sale">
            <a class="shop-item" target="_blank" href="https://mst.vip.com/pY4UXyQ7V78OaUhSLTzXiw.php?client=pc&wapid=mst_2750780&extra_type=3"><img src="../assets/images/mobile/weipin.png" alt=""></a>
          </div>
        </section>
        <section class="foot-line-big">
          <div></div>
        </section>
        <section class="footer-middle">
          <div class="footer-middle-item">
            <div @click="dialog({type:1,open:true})">联系我们</div>
          </div>
          <div class="footer-middle-item footer-middle-item-2">
            <div @click="dialog({type:2,open:true})">隐私政策</div>
          </div>
        </section>
        <section class="foot-line-small">
          <div></div>
        </section>
        <section class="footer-delail">
          <!--<div>泸公网安备XXXXXX</div>-->
          <div>天创时尚股份有限公司版权所有 </div>
          <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备11000016号</a>

        </section>
      </footer>
      <div class="contact-us-template" :class="mask?'contact-us-template-show':'contact-us-template-hide'">
        <div class="close-contact-us" @click="mask= false">
          <img style="background-color: #ffffff;width: 25%;height: 25%;" src="../assets/images/common/close.png"/>
        </div>
        <div v-if="dialogType===1">
          <h3 class="contact-title">联系我们</h3>
          <div class="sale-after-telephone">
            <h4 class="title">售后电话</h4>
            <div class="content">02039301600<a style="font-size: .3rem;margin-left: .2rem;color: #1E90FF;" href="tel:02039301600">立刻拨打</a></div>

          </div>
          <div class="sale-after-telephone">
            <h4 class="title">总部地址</h4>
            <div class="content">广州市南沙区东涌镇银沙大街31号</div>
          </div>
        </div>

        <div v-else-if="dialogType===2">
          <h3 class="contact-title">隐私政策</h3>
        </div>

        <div v-else-if="dialogType===3">
          <h3 class="contact-title">扫码关注我们</h3>
          <div class="weixin-qrcode">
            <img src="../assets/images/pc/weixin.jpg"/>
          </div>
        </div>

      </div>
      <div class="foot-contact-us-bacground" @click="mask = false"
           :style="mask?'display:block':'display:none'"></div>
    </div>

  </div>
</template>

<script>
import {
  mapState, mapActions, mapMutations
} from 'vuex'
export default {
  data () {
    return {
      shop: '',
      mask: false, // 遮罩层
      dialogType: 1 // 1:联系我们/2:隐私政策/3:微信公众号二维码
    }
  },
  computed: {
    ...mapState(['provinceData'])
  },
  methods: {
    ...mapActions(['getProvinceAction', 'getNearestShopAction']),
    ...mapMutations(['changeShopID']),
    toShopPage () {
      this.changeShopID(this.shop)
      this.$router.push({name: 'TS_shop', params: {id: this.shop}})
      this.$route.params.id = this.shop
    },
    dialog (e) {
      let {type, open} = e
      this.mask = open
      this.dialogType = type
    },
    // 查询附近店铺
    getNearestShop () {
      let _this = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, showError)
      } else {
        alert('该浏览器不支持获取地理位置。')
      }

      function showPosition (position) {
        _this.$router.push({name: 'TS_shop_near', params: { latitude: position.coords.latitude, longitude: position.coords.longitude }})
      }

      function showError (error) {
        alert(error)
      }
    }
  },
  watch: {
    'shop': 'toShopPage'
  },
  created () {
    this.getProvinceAction()
  }
}
</script>

<style lang="less" scoped>
  @import "footer";
  @import "footerMobile";
</style>



// WEBPACK FOOTER //
// src/layout/footer.vue